import {tns} from 'tiny-slider/src/tiny-slider';

export const tnsService = {
    initTns: (params) => {
        tns({
            container: params.container,
            loop: true,
            autoplay: true,
            nav: false,
            controls: false,
            speed: 500,
            onInit: params.onInit
        });
    },
};
